<template>
  <div>
    <div class="container">
      <div class="inner">
        <div class="back-wrapper">
          <button class="secondary back">{{ $t('view.component.common.buttonBack') }}</button>
        </div>
        <h1 class="main-title">{{ $t('view.component.user.activate.header') }}</h1>
        <div v-if="isLoading">
          <div class="with-loading loader-info">
            <Loader />
          </div>
        </div>
        <div class="form-wrapper">
          <div class="status-view account-registered" v-if="showConfirmation">
            <div class="img-wrapper">
              <div class="img">
                <img alt="" src="../../assets/images/topup-success.svg" />
              </div>
              <div>
                <h2>{{ $t('view.component.user.activate.confirmationHeader') }}</h2>
                <p v-html="$t('view.component.user.activate.confirmationInfo')"></p>
              </div>
            </div>
            <div class="submit-wrapper">
              <button class="primary" @click="goToLogin">{{ $t('view.component.user.activate.buttonLogin') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ROUTING } from '@/orange/const/routing.const'
import { Notifier, NOTIFY_TYPE } from '@/common/class/notify.class'
import Loader from '@/orange/components/Loader'

export default {
  name: 'UserActivateView',
  components: { Loader },
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showConfirmation: false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isUserLoading'
    })
  },
  methods: {
    ...mapActions([
      'doUserAccountActivate'
    ]),
    goToLogin () {
      this.$router.push(ROUTING.user.login)
    },
    goToHomePage () {
      this.$router.push(ROUTING.main)
    }
  },
  mounted () {
    if (!this.token || !this.token.length) {
      this.goToHomePage()
      return
    }

    this.doUserAccountActivate(this.token)
      .then(() => {
        this.showConfirmation = true
      })
      .catch(() => {
        Notifier.show({
          text: this.$t('view.component.user.activate.errorProcessInfo'),
          type: NOTIFY_TYPE.error
        })
        this.goToHomePage()
      })
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_login-register.scss" scoped></style>
